<template>
  <div class="opportunities-menu">
    <div class="extended-block">
      <h6>Initiatives</h6>
      <menu-item
        path="/about/deals"
        text="All opportunities"
        caption="Find the digital engagements that suit your business best"
        @click="handleItemClick('/about/deals')"
      />
    </div>
    <div v-if="spotlight.length" class="extended-block center-block">
      <h6>Opportunity spotlight</h6>
      <menu-item
        v-for="item in spotlight"
        :key="item.id"
        :path="`/deals/platforms/${item.path}`"
        :text="item.title"
        :caption="item.subtitle"
        @click="handleItemClick(`/deals/platforms/${item.path}`)"
      />
    </div>
    <div v-if="showMyProposalsLink" class="extended-block user-block">
      <user-menu-item
        path="/deals/submissions"
        text="My proposals"
        :caption="proposalCaption"
        @click="handleItemClick('/deals/submissions')"
      />
    </div>
  </div>
</template>

<script>
import MenuItem from './menu-item'
import UserMenuItem from './user-menu-item'
import featureToggles from 'src/settings/feature-toggles'

export default {
  name: 'opportunities-menu',
  components: {
    MenuItem,
    UserMenuItem,
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn
    },
    platforms() {
      return this.$store.getters['dealbook/orderedPlatforms']
    },
    spotlight() {
      if (this.platforms.length) {
        return this.platforms.filter(p => !p.closed).slice(0, 3)
      }
      return []
    },
    showMyProposalsLink() {
      return !featureToggles.disableMyProposals
    },
    proposalCaption() {
      return this.isLoggedIn
        ? 'Update your proposals and track their progress'
        : 'Sign in to update your proposals and track their progress'
    },
  },
  methods: {
    handleItemClick(path) {
      this.$emit('hide')
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'top-menu-navigate',
        eventLabel: 'Path ' + path,
      })
      this.$gtag.event('top-menu-navigate', {
        'event_category': 'Click',
        'event_label': 'Path ' + path,
      })
    },
  },
}
</script>

<style scoped lang="scss">
.opportunities-menu {
  display: flex;
  flex-direction: column;
  padding: 0;
  @include desktop {
    min-width: 800px;
    flex-direction: row;
  }
}
.extended-block {
  padding: $padding-l;
  h6 {
    font-size: $header-label-size;
    font-weight: 600;
    margin-bottom: $margin-m;
    text-transform: uppercase;
    color: $header-secondary-color;
  }
}
.center-block {
  width: 500px;
}
.user-block {
  padding: $padding-l;
  background: #fffae9;
}
</style>
